<template>
  <b-input-group>
    <b-form-input
      :id="id"
      :value="value"
      :type="visible ? 'text' : 'password'"
      :state="state"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      @input="$emit('input', $event)"
      @blur="$emit('blur', $event)"
    />
    <b-input-group-append>
      <b-button
        variant="outline-secondary"
        type="button"
        v-b-tooltip.hover
        :title="visible ? $t('auth.hide_password') : $t('auth.show_password')"
        :aria-label="visible ? $t('auth.hide_password') : $t('auth.show_password')"
        @click="visible = !visible"
      >
        <b-icon :icon="visible ? 'eye-slash' : 'eye'" />
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
  export default {
    name: 'PasswordInput',

    data () {
      return {
        visible: false,
      }
    },

    props: {
      value: {
        type: String,
        default: null,
      },
      id: {
        type: String,
        required: true,
      },
      state: {
        type: Boolean,
        default: null,
      },
      placeholder: {
        type: String,
        required: false,
      },
      autocomplete: {
        type: String,
        default: 'current-password',
      },
    },
  }
</script>

<style scoped>

</style>
